import { useEffect, useRef, useState } from "react";

export function useDropdownVisible(initialIsVisible: boolean): any {
  const wrapperRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(initialIsVisible);
  // below is the same as componentDidMount and componentDidUnmount
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  // Opening/toggling is entirely the consuming component's own job (e.g. BusinessFunctionInput.tsx/
  // GeographicalScopeInput.tsx toggle isVisible themselves via their own wrapping .dropdown div's
  // onClick) - this listener's only job is closing the dropdown when a
  // click lands outside the wrapper. It used to also unconditionally force setIsVisible(true) on
  // EVERY click anywhere in the document (any target that wasn't literally the arrow_down <span>),
  // regardless of whether that click was even related to this dropdown instance. Since this native
  // document listener fires after the component's own React onClick handler for the same click
  // (e.g. selecting an option, which explicitly calls setIsVisible(false) to close the list), that
  // unconditional true silently won the same-click state update every time - reopening the list the
  // instant an option was clicked, making selection look broken. It also meant clicking anywhere
  // else on the page (any other field, even a different dropdown's own option) could pop this
  // dropdown back open, since the check ran with no relation to wrapperRef at all.
  const handleClickOutside = (event: Event) => {
    const currentElement = event.target as Element;
    if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node) && currentElement.localName !== "span") {
      setIsVisible(false);
    }
  };

  return { wrapperRef, isVisible, setIsVisible };
}
export function useMetricVisible(initialIsVisible: boolean): any {
  const metricRef = useRef<HTMLElement>(null);
  const [isMetricVisible, setIsMetricVisible] = useState(initialIsVisible);
  // below is the same as componentDidMount and componentDidUnmount
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event: Event) => {
    const clickedElement = event.target as Element;
    if (metricRef.current && !metricRef.current.contains(event.target as Node) && clickedElement.className !== "metric-option") {
      setIsMetricVisible(false);
    }
  };

  return { metricRef, isMetricVisible, setIsMetricVisible };
}

export function useMultiselectVisible(initialIsVisible: boolean): any {
  const wrapperRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(initialIsVisible);
  // below is the same as componentDidMount and componentDidUnmount
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event: Event) => {
    const clickedElement = event.target as Element;
    const classNameValue = clickedElement.className;
    if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
      if (typeof classNameValue === "string" && classNameValue.includes("multiselect")) {
        setIsVisible(true);
      }
      setIsVisible(false);
    }
  };

  return { wrapperRef, isVisible, setIsVisible };
}
